import { BOOKMARK_LISTNAME_FAVORITE } from "constants/config";
import { IBookmarkListItem } from "helpers/bookmark";
import { bookmarkListDetailPagePath } from "helpers/pageUrl";
import { useRouter } from "next/router";
import BookmarkListItem from "./BookmarkListItem";
import BookmarkListItemActionButton from "./BookmarkListItemActionButton";

type BookmarkListItemWithActionsProps = {
  bookmarkList: IBookmarkListItem;
  onClickEditList: () => void;
  onClickDeleteList: () => void;
};

/**
 * @component BookmarkListItemWithActions
 * @description a card displaying a bookmark list for the bookmarks page.
 * @example
 * return (
 *   <BookmarkListItemWithActions
 *      bookmarkList={bookmarkList}
 *      onClickEditList={() => {
 *        handleClickEditList(bookmarkList.id);
 *      }}
 *      onClickDeleteList={() => {
 *        handleClickDeleteList(bookmarkList.id);
 *      }}
 *    />
 * )
 */
function BookmarkListItemWithActions({
  bookmarkList,
  onClickDeleteList,
  onClickEditList,
}: BookmarkListItemWithActionsProps) {
  const isFavorite = bookmarkList.text_label == BOOKMARK_LISTNAME_FAVORITE;

  const router = useRouter();
  const handleListItemClicked = () => {
    const link = bookmarkListDetailPagePath(bookmarkList.id);
    router.push(link);
  };

  return (
    <BookmarkListItem
      bookmarkList={bookmarkList}
      onListItemClicked={handleListItemClicked}
    >
      {!isFavorite && (
        <BookmarkListItemActionButton
          onClickEditList={onClickEditList}
          onClickDeleteList={onClickDeleteList}
        />
      )}
    </BookmarkListItem>
  );
}

export default BookmarkListItemWithActions;
